import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('leads'),
  rootKey: 'lead',
});



// WEBPACK FOOTER //
// ./app/models/lead.js